import { Card, CardContent, Grid, Typography } from '@mui/material';
import ChartHelpTooltip from './ChartHelpTooltip';

interface SMTCardProps {
  size: number;
  name: string;
  value: number | string;
  unit: string;
  help?: string;
}

const SMTCard = ({ size, name, value, unit, help }: SMTCardProps) => {
  return (
    <Grid xs={12} md={size} xl={size} item sx={{ p: 0 }}>
      <Card>
        <CardContent>
          <Typography color="text.primary" sx={{ mt: 1, fontSize: '1rem', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
            {name}
            {help && <ChartHelpTooltip chartType={help} />}
          </Typography>
          <Typography color="text.primary" sx={{ mt: 1, fontSize: '2rem', fontWeight: '400', display: 'inline-block' }}>
            {value}
          </Typography>{' '}
          <Typography color="text.primary" sx={{ mt: 1, fontSize: '1rem', fontWeight: '400', display: 'inline-block' }}>
            {unit ? unit : ''}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SMTCard;
